<template>
  <div class="compare w1200">
    <div class="nav">
      <span style="color: #808080">当前位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/productHome' }"
          >首页</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/productHome' }"
          >产品选型</el-breadcrumb-item
        >
        <el-breadcrumb-item>产品对比</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="comparebox">
      <div class="comparebox_pro">
        <div class="comparebox_pro_left">
          <p>已选产品数： {{ this.productList.length }}</p>
          <div style="margin-bottom: 15px">
            <el-radio v-model="checkOne" label="1" @change="getCheck">凸显差异数据</el-radio>
          </div>
          <div>
            <el-radio v-model="checkOne" label="2">凸显相同数据</el-radio>
          </div>
          <!-- <div class="clear_box" @click="getClearList">
            <i class="el-icon-delete"></i>
            <span>清除列表</span>
          </div> -->
          <el-button type="primary" plain @click="deriveReport" class="clear_box"
            >导出选型报告</el-button
          >
        </div>
        <div class="comparebox_pro_box" ref="container">
          <div
            class="comparebox_pro_right"
            v-for="(item, index) in productList"
            :key="index"
          >
            <i
              class="el-icon-circle-close iconfontClose"
              @click="deletProductList(index)"
            ></i>
            <img :src="item.coverImages[0].url" alt="" />
            <div class="text_overfolw" style="font-size:18px;font-weight:600">{{ item.name }}</div>
            <div class="text_overfolw" style="font-size:14px;margin-top:10px">{{ item.productName }}</div>
            <div class="flex comparebox_pro_right_btn">
              <el-button type="primary" plain @click="getDetails(item.uuid)"
                >查看详情</el-button
              >
              <p class="pro_text" @click="getInquiry(item.uuid)">立即询价</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="productList.length > 0" class="comparebox_pro_list">
        <div
          class="comparebox_nums"
          v-for="(itemPro, indexPro) in productList[0].paramsObject"
          :key="indexPro"
        >
          <p class="comparebox_nums_title">{{ indexPro }}</p>
          <div class="comparebox_nums_box">
            <div class="comparebox_nums_name box">
              <p v-for="(item, index) in itemPro" :key="index">
                {{ item.name }}
              </p>
            </div>
            <div
              style="display: flex; width: 960px; overflow: scroll"
              class="comparebox_nums_boxP"
              ref="rightData"
            >
              <div
                class="comparebox_nums_name box comparebox_nums_co comparebox_nums_box_right"
                v-for="(item, index) in dataList"
                :key="index"
              >
                <p
                  v-for="(itemS, indexS) in item[indexPro]"
                  :key="indexS"
                  :style="`color: ${
                    checkOne == 1
                      ? itemS.isShow
                        ? 'black'
                        : 'red'
                      : itemS.isShow
                      ? itemS.color
                      : 'black'
                  }`"
                >
                  {{ itemS.value }}{{ itemS.unit }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <inquiry ref="inquireRef"></inquiry>
  </div>
</template>

<script>
// 询价
import inquiry from "./components/inquiry";
import { utils, writeFileXLSX } from "xlsx";
import { nextTick } from 'vue';
export default {
  components: {
    inquiry,
  },
  data() {
    return {
      checkOne: "1",
      productList: [],
      stateList: [],
      stateListOther: [],
      dataList: [],
      colorChange: null,
      productList2: [],
      colorIndex: 0
    };
  },
  mounted() {
    this.getDataList(this.$store.state.checkList);
    const container = this.$refs.container;
    nextTick(()=> {
      const rightData = this.$refs.rightData;
      for(let i = 0; i < rightData.length; i++) {
        container.addEventListener('scroll', () => {
          rightData[i].scrollLeft = container.scrollLeft;
        });
        rightData[i].addEventListener('scroll', () => {
          rightData[i].scrollLeft = rightData[i].scrollLeft;
          container.scrollLeft = rightData[i].scrollLeft;
        });
      }
    })

  },
  watch: {
    "$store.state.checkList"(val) {
      this.productList = []
      this.dataList = []
   
      this.productList2.map((item) => {
        val.map((item2) => {
          if (item.uuid == item2) {
            this.productList.push(item);
          }
        });
      });
       this.productList.map((item, index) => {
         let params = {
          '厂家':[{name:'厂家',value:item.company}],
          ...item.paramsObject
        }
        this.productList[index].paramsObject = params
        this.dataList.push(params);
        Object.keys(this.dataList[0]).forEach((item) => {
          this.changeData(this.dataList, item);
        });
      });
    },
    "$store.state.compare"(val) {
      this.getDataList(this.$store.state.checkList);
    },
  },
  methods: {
    getCheck() {},
    // 获取数据
    getDataList(val) {
      // val 是产品对比里的选中的数据

      // 多窗口选完后， 对比出来的选中的数据
      this.productList = []
      let compareList = val;
      // let compareList = this.$store.state.checkList;
      // let productList2 = this.$store.state.compare;
      
      // 产品对比多窗口情况选的所有的数据，选中和未选中
      this.productList2 = JSON.parse(localStorage.getItem('lostCompare'));
      
      //数据对比 uuid 有相同的就push到this.productList里
      this.productList2.map((item) => {
        compareList.map((item2) => {
          if (item.uuid == item2) {
            this.productList.push(item);
          }
        });
      });

      this.stateList = [];
      this.dataList = [];
      this.productList.map((item, index) => {
        let params = {
          '厂家':[{name:'厂家',value:item.company}],
          ...item.paramsObject
        }
        this.productList[index].paramsObject = params
        this.dataList.push(params);
      });
      console.log('this.dataList',this.dataList);
      // console.log("productList",JSON.parse(JSON.stringify(this.productList)),JSON.parse(JSON.stringify(this.dataList)))
      Object.keys(this.dataList[0]).forEach((item) => {
        this.changeData(this.dataList, item);
      });
    },
    getInquiry(uuid) {
      if (!this.$store.state.isLogin) {
        this.$router.push({
          name: "login",
        });
        return false;
      } else {
        this.$refs.inquireRef.init(uuid);
      }
    },
    changeData(list, baozhuang) {
      let arr = [];
      // 获取baozhuang的最大长度
      let num = list[0][baozhuang].length;
      list.forEach((item, index) => {
        if (num < item[baozhuang].length) {
          num = item[baozhuang].length;
        }
      });

      // 追加二维数组 arr = [[],[],[]]
      for (let i = 0; i < num; i++) {
        arr.push([]);
      }

      /**
       * arr的下标是按最长的数据添加的，有空数据的情况
       * 短的数据的取的时候会是空值，空值要展示“-”，所以要做判断
       */
      arr.forEach((item1, index1) => {
        list.forEach((item2, index2) => {
          if(item2[baozhuang][index1]) {
            if(item2[baozhuang][index1].value) {
              //     item2[baozhuang][index1]没有值 val给“-”    
              item1.push(item2[baozhuang][index1] || { val: "-" });
            } else {
              item2[baozhuang][index1].value = "-"
            }
          }
        });
      });

      arr.forEach((item1, index1) => {
        let indexList = []
        let indexObj = {}
        // 循环找出一行数据中相同的， 给一样的颜色 和 isShow为true
        // .isShow 数据是否一样 true 为一致
        // .color 控制字体颜色
        item1.forEach((item4,index4)=>{
          // let color = this.color16()
          item1.forEach((item5,index5)=>{
            if (
              item4.value == item5.value
              && index4 != index5
            ) {
              indexList.push(item4.value) // 添加value 下面去重
              indexList.push(item5.value)
            }
          })
        })
        // 去重
        let setlist = Array.from(new Set(indexList))
        // 下标是对象， 对象中的value是值，用于对比， color是值对应的颜色，一样的值用相同的颜色
        let setlistObj = []
        // 重置颜色为红色
        this.colorIndex = 0
        setlist.forEach((item8,index8)=>{
          setlistObj.push({
            value : item8, 
            color: this.color16()
          })
          this.colorIndex+=1
        })
        console.log('list',list);
        setlistObj.forEach((item7,index7)=>{
          item1.forEach((item6,index6)=>{
            // 一样的值用相同的颜色
            if(item7.value == item6.value){
              item6.color = item7.color
              item6.isShow = true
            }
          })
        })
        // 改变下次的颜色
        this.colorIndex++
        list.forEach((item3, index3) => {
          // 如果有值， 因为arr的下标是按最长的数据添加的有空数据的情况
          if (item3[baozhuang][index1]) {
            if(item1[index3]) {
              item3[baozhuang][index1].isShow = item1[index3].isShow;
            }
          }
        });

      });
    },
     color16(){//十六进制颜色随机
      let color = ["#e23e00","#fdb23e","#2d50a1","#11b211","#7812ca"]
      if(this.colorIndex >= 5) {
        this.colorIndex = 0
      }
      return color[this.colorIndex];
    },

    getClearList() {
      this.productList = [];
      this.$store.commit("checkListVuex", []);
    },
    getDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "productDetails",
      });
      window.open(routeData.href + "?uuid=" + uuid, "_blank");
    },
    // 导出
    deriveReport() {
      // let lostCompare = JSON.parse(localStorage.getItem('lostCompare'))
      let lostCompare = this.productList
      let biaotou = []
      let paramsObject = lostCompare[0].paramsObject
      if( paramsObject.厂家){
        delete paramsObject.厂家
      }
      for (const key in paramsObject) {
        biaotou.push({fu: key, list:[key], isAdd: false})
        paramsObject[key].forEach((item2,index2)=>{
          biaotou.push({fu: key, list:[item2.name], isAdd: true})
        })
      }
      lostCompare.forEach(item1=>{
        for (const key in item1.paramsObject) {
          item1.paramsObject[key].forEach(item3=>{
            biaotou.forEach(item2=>{
              if (item2.fu == key && item2.list[0] == item3.name) {
                item2.list.push(`${item3.value}${item3.unit}`)
              }
            })
          })
            
        }
      })
      // console.log('biaotou',biaotou);
      let list = []
      biaotou.forEach(item=>{
        list.push(item.list)
      })
      let workT = [""]
      this.productList.map(item => {
        workT.push(item.name)
      })
      list.unshift(workT)
      let worksheet = utils.aoa_to_sheet(list);
      // 创建一个新的工作簿
      const workbook = utils.book_new();
      // 把工作表添加到工作簿
      utils.book_append_sheet(workbook, worksheet, "Data");
      // 改写表头
      // utils.sheet_add_aoa(worksheet, [workT]);
      writeFileXLSX(workbook, "产品对比.xlsx");
    },
    // 删除一个数据
    deletProductList(index) {
      let checkList = [];
      if (this.productList.length <= 2) {
        this.$message({
          message: "对比需有两条以上数据",
          type: "warning",
        });
        return;
      }
      this.productList.splice(index, 1);
      this.dataList.splice(index, 1);
      this.productList.map((item) => {
        checkList.push(item.uuid);
        this.$store.commit("checkListVuex", checkList);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "./style/index";
.compare {
  margin-bottom: 80px;
}
.text_overfolw{
  white-space: nowrap !important;
  width: 200px;
  overflow: hidden;
  margin: 0 auto;
  text-overflow: ellipsis;
}
.comparebox_pro {
  border: 1px solid #efefef;
  display: flex;
  .comparebox_pro_left {
    flex-shrink: 0;
    text-align: center;
    border-right: 1px solid #efefef;
    padding: 50px;
    width: 238px;
    box-sizing: border-box;
    p {
      margin-bottom: 20px;
    }
    .clear_box {
      margin-top: 40px;
      margin-bottom: 20px;
    }
  }
  .comparebox_pro_box {
    display: flex;
    overflow-x: auto;
    .comparebox_pro_right {
      flex-shrink: 0;
      width: 240px;
      text-align: center;
      padding: 20px;
      border-right: 1px solid #efefef;
      box-sizing: border-box;
      position: relative;
      img {
        width: 200px;
        height: 140px;
        margin-bottom: 10px;
      }
      .pro_text {
        font-size: 14px;
        margin: 12px;
        cursor: pointer;
        color: #2d50a1;
      }
      .iconfontClose {
        position: absolute;
        top: 25px;
        right: 25px;
        font-size: 18px;
        color: rgb(153, 153, 153);
        cursor: pointer;
      }
      .comparebox_pro_right_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
      }
    }
  }
}
.comparebox_pro_list {
  overflow: auto;
  height: 700px;
}
.comparebox_nums {
  .comparebox_nums_title {
    background: #efefef;
    padding: 20px;
    font-weight: bold;
    font-size: 18px;
  }
  .comparebox_nums_box {
    display: flex;
    .comparebox_nums_boxP::-webkit-scrollbar {
      display: none;
    }
    .comparebox_nums_box_right {
      overflow-x: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .comparebox_nums_name {
    p {
      padding-left: 20px;
    }
  }
  .comparebox_nums_co {
    text-align: center;
  }
  .box {
    width: 240px;
    flex-shrink: 0;
    text-align: center;
    p {
      border: 1px solid #efefef;
      height: 60px;
      line-height: 60px;
    }
  }
}
.params_map {
  .cell {
    background: #eee;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/productCompare.vue